import { useContext, useEffect, useMemo, useRef, useState } from "react";
import Slider from "react-slick";
import { useDataSlider } from "../../main-cover-hook";
import styles from "./main-cover-2.module.css";
import { UiButton } from "@ui-monorepo/index";
import { LazyVideo } from "../../../../";
import WidgetContainer from "../../../widget-container";
import { ContentCoverContext } from "../../main-cover.context";
import ArrowsSliderCover from "../components/arrows-slider-covers/arrows-slider-covers";

const MainCover2 = () => {
  const { theme, isMobile, storeMetadata, stepToPause } = useContext(ContentCoverContext);
  const { handleClickScroll, items } = useDataSlider();
  const sliderRef = useRef<Slider>(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const settings = {
    centerMode: true,
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 1,
    autoplay: true,
    adaptiveHeight: true,
    speed: 400,
    dots: true,
    variableWidth: true,
    prevArrow: <ArrowsSliderCover userTheme={theme} />,
    nextArrow: <ArrowsSliderCover userTheme={theme} />,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }],

    beforeChange: (current: number, next: number) => setActiveSlide(next)
  };

  const videoIsActive = useMemo(() => {
    return !!items[activeSlide]?.video;
  }, [activeSlide, items]);

  useEffect(() => {
    if (!!stepToPause || stepToPause === 0) {
      sliderRef?.current?.slickGoTo(stepToPause);
      sliderRef?.current?.slickPause();
    } else {
      sliderRef?.current?.slickPlay();
    }
  }, [stepToPause]);

  useEffect(() => {
    if (videoIsActive) {
      sliderRef.current?.slickPause();
    } else {
      sliderRef.current?.slickPlay();
    }
  }, [videoIsActive]);

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      fullWidth={items.length > 1}>

      <div className={styles.mainBannerCloudStyle}>
        <Slider ref={sliderRef} {...settings} centerMode={items.length > 1}>
          {items.map((item, index) =>
          <div key={`cover2-item-${index}`}>
              <div
              className={`slider-card ${styles.sliderCard} ${
              items.length > 1 ?
              `${styles.marginMultipleSlides}` :
              `${styles.marginOneSlide}`
              }`}>

                <div
                className={` ${styles.sliderImg}  ${
                item?.video ? `${styles.sliderZnone}` : `${styles.sliderZ}`
                }`}>

                  {item?.video &&
                <LazyVideo
                  storeMetadata={storeMetadata}
                  videoUrl={item.video}
                  play={videoIsActive}
                  className={"slider-cover-2"}
                  borderRadius={"10px"}
                  theme={theme} />}


                  {item?.imageDesktop && !isMobile &&
                <img
                  src={item?.imageDesktop}
                  className={styles.portraitImg}
                  alt={"slider-img"}
                  loading='eager' />}


                  {item?.imageMobile && isMobile &&
                <img
                  src={item?.imageMobile}
                  className={styles.portraitImg}
                  alt={"slider-img"}
                  loading='eager' />}


                </div>
                {!item.video && (
              item.config?.enabled || item.config?.enabled_button) &&
              <div className={styles.sliderBox}>
                      <div
                  className={`${
                  styles[item.config?.position || "center"]
                  } ${styles.sliderBoxTitle}`}>

                        {item.config?.enabled && item.title &&
                  <div className={styles.sliderBoxTitleText}>
                            {item.title &&
                    <h1 className={styles.sliderSellerName}>
                                {item?.title}
                              </h1>}

                          </div>}

                        {item.config?.enabled_button && item.link &&
                  <UiButton
                    isFilled
                    onClick={() =>
                    handleClickScroll(
                      item?.link?.value,
                      item.link?.elementId
                    )}

                    theme={theme}>

                            <div className={styles.sliderSellerBtnText}>
                              {item?.link?.label}
                            </div>
                          </UiButton>}

                      </div>
                    </div>}

              </div>
            </div>
          )}
        </Slider>
      </div>
    </WidgetContainer>);

};

export default MainCover2;